import usePipelineStore from '../../../../stores/pipeline-store';
import { DrawerSelect } from './DrawerSelect';

type VarType = 'STRING' | 'NUMBER' | 'BOOLEAN' | 'REF';

type VarSelectProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    filterByType?: VarType[];
    width?: string | number;
    /** If set, show an enabled empty option with this label (e.g. "Ignore response") */
    emptyOptionLabel?: string;
    disabled?: boolean;
};

export function VarSelect({
    value,
    onChange,
    placeholder = 'Select Var',
    filterByType,
    width,
    emptyOptionLabel,
    disabled,
}: VarSelectProps) {
    const pipeline = usePipelineStore((state) => state.pipeline);
    const vars = pipeline.vars || {};
    const keys = Object.keys(vars);
    const filteredKeys = filterByType
        ? keys.filter((key) => filterByType.includes(vars[key].type as VarType))
        : keys;
    const sortedKeys = [...filteredKeys].sort((a, b) =>
        (vars[a].name ?? '').localeCompare(vars[b].name ?? '', undefined, { sensitivity: 'base' }),
    );

    return (
        <DrawerSelect
            value={value}
            width={width}
            isDisabled={disabled}
            onChange={(e) => onChange(e.target.value)}
        >
            <option value="" disabled={!emptyOptionLabel}>
                {emptyOptionLabel ?? placeholder}
            </option>
            {sortedKeys.map((key) => (
                <option key={key} value={key}>
                    {vars[key].name}
                </option>
            ))}
        </DrawerSelect>
    );
}
